/**
 * Based on the incoming company attribute, this component will
 * render the appropriate component.  In some cases the company component
 * may include a logo, in some cases it will only be text.
 */

import React from 'react';
import Ask from './ask';
import Argent from './argent';
import Michelle from './michelle';
import Tcb from './tcb';
import { View } from '@react-pdf/renderer';

function ReportHeader({ company }: any) {
  return (
    <View>
      {company === 'argent' && <Argent />}
      {company === 'tcb' && <Tcb />}
      {company === 'michelle' && <Michelle />}
      {company === 'ask' && <Ask />}
    </View>
  );
}

export default ReportHeader;
